import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { divisionsToolTable, tableMenuItems } from "../../adminData";
import {
  CheckCircleIcon,
  XMarkIcon,
  EllipsisVerticalIcon,
} from "@heroicons/react/24/outline";
import CreditRequestSvg from "../../svgIcons/CreditRequestSvg";
import GlobalTableDropDown from "../../GlobalTableDropDown";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const DivisionsToolTable = ({
  profession,
  handleDropDownMenu,
  isEditId,
  setEditInputId,
}) => {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(null);

  useEffect(() => {
    window.addEventListener("click", () => {
      setShowMenu(false);
    });
    return () => {
      window.removeEventListener("click", () => {
        setShowMenu(false);
      });
    };
  }, []);

  const handleMenuItems = (userId, flag) => {
    if (!flag) {
      setShowMenu(userId.id);
    } else {
      setShowMenu(null);
    }
  };

  const handleDivisionNavigation = (division) => {
    navigate(`/admin-dashboard/admin-tools/${profession.id}/${division.id}`, {
      state: {
        profession: profession,
        division: division,
      },
    });
  };

  return (
    <>
      <div className="px-4 sm:px-6 lg:px-8 hidden md:block">
        <div className="mt-8 flow-root">
          <div className="table-scroller -mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 bg-white border border-[#EBEFF3] rounded-md p-5">
            <div className="inline-block min-w-full py-2 align-middle">
              <div className="relative">
                <table className="min-w-full table-fixed divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-bold text-[#485868]"
                      >
                        # ID
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                      >
                        Name
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                      >
                        Price per lead
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                      >
                        Services
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                      >
                        Created at
                      </th>
                      <th
                        scope="col"
                        className="relative py-3.5 pl-3 pr-4 sm:pr-0"
                      >
                        <span className="sr-only"></span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {divisionsToolTable.map((division, index) => (
                      <tr
                        className="cursor-pointer hover:bg-[#EBF7FF]"
                        key={division.id}
                        onClick={() => handleDivisionNavigation(division)}
                      >
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                          {division.id}
                        </td>
                        <td
                          className={classNames(
                            "whitespace-nowrap py-4 pr-3 text-sm font-normal text-customGray"
                          )}
                        >
                          {division.name}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                          <div className="flex items-center gap-3">
                            <div
                              className={`h-9 rounded-md border border-[#EBEFF3] py-2 px-3 w-[96px] ${
                                division.id == isEditId
                                  ? "bg-white"
                                  : "bg-[#F1F4F6]"
                              } flex items-center justify-center`}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <span className="data-base-svg w-[18px] h-[18px] mr-2.5">
                                <CreditRequestSvg />
                              </span>
                              <input
                                type="text"
                                // value={division.price_per_lead}
                                ref={(node) =>
                                  division.id == isEditId && node?.focus()
                                }
                                placeholder="100"
                                onClick={(e) => e.stopPropagation()}
                                disabled={division.id != isEditId}
                                className="bg-transparent text-sm font-normal leading-[140px] text-customGray border-l border-[#EBEFF3] pl-2.5 h-5"
                              />
                            </div>
                            {division.id == isEditId && (
                              <div className="flex items-center justify-center gap-2">
                                <CheckCircleIcon className="w-6 h-6 text-[#16CA7C] cursor-pointer" />
                                <XMarkIcon
                                  className="w-6 h-6 text-[#EF2121] cursor-pointer"
                                  onClick={(e) => {
                                    setEditInputId(null);
                                    e.stopPropagation();
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                          {division.services}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                          {division.created_at}
                        </td>
                        <td>
                          <GlobalTableDropDown
                            data={division}
                            showMenu={showMenu === division.id}
                            callBack={handleMenuItems}
                            isLastIndex={index == divisionsToolTable.length - 2}
                            menuItems={tableMenuItems}
                            handleDropDownMenu={handleDropDownMenu}
                            setShowMenu={setShowMenu}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="block md:hidden">
        <div>
          <ul>
            {divisionsToolTable &&
              divisionsToolTable.map((division, index) => (
                <li
                  className="border border-solid border-[#EBEFF3] rounded-md p-5 mb-[14px] flex justify-between bg-[#ffffff]"
                  onClick={() => handleDivisionNavigation(division)}
                >
                  <ul>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        # ID
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {division.id}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Name
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {division.name}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Price per lead
                      </h6>
                      <div className="flex items-center gap-3">
                        <div
                          className={`h-9 rounded-md border border-[#EBEFF3] py-2 px-3 w-[96px] ${
                            division.id == isEditId
                              ? "bg-white"
                              : "bg-[#F1F4F6]"
                          } flex items-center justify-center`}
                        >
                          <span className="data-base-svg w-[18px] h-[18px] mr-2.5">
                            <CreditRequestSvg />
                          </span>
                          <input
                            type="text"
                            // value={division.price_per_lead}
                            ref={(node) =>
                              division.id == isEditId && node?.focus()
                            }
                            placeholder="100"
                            onClick={(e) => e.stopPropagation()}
                            disabled={division.id != isEditId}
                            className="bg-transparent text-sm font-normal leading-[140px] text-customGray border-l border-[#EBEFF3] pl-2.5 h-5"
                          />
                        </div>
                        <div className="flex items-center justify-center gap-2" onClick={(e) => e.stopPropagation()}>
                          <CheckCircleIcon className="w-6 h-6 text-[#16CA7C] cursor-pointer" />
                          <XMarkIcon
                            className="w-6 h-6 text-[#EF2121] cursor-pointer"
                            onClick={(e) => {
                              setEditInputId(null);
                              e.stopPropagation();
                            }}
                          />
                        </div>
                      </div>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Services
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {division?.services}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Created At
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {division?.created_at}
                      </span>
                    </li>
                  </ul>
                  <div>
                    <GlobalTableDropDown
                      data={division}
                      showMenu={showMenu === division.id}
                      callBack={handleMenuItems}
                      isLastIndex={index == divisionsToolTable.length - 2}
                      menuItems={tableMenuItems}
                      handleDropDownMenu={handleDropDownMenu}
                      setShowMenu={setShowMenu}
                    />
                  </div>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default DivisionsToolTable;
